import { Button } from 'native-base';
import PropTypes from 'prop-types';
import React from 'react';

function ActionButton({ children, ...props }) {
  return (
    <Button
      {...props}
      bg="#ffb703"
      _pressed={{
        bg: '#ffa602',
      }}
      _text={{
        bold: true,
      }}
      size="lg"
      borderRadius="30"
      py="4"
      px="6"
      m="4"
    >
      {children.toUpperCase()}
    </Button>
  );
}

ActionButton.propTypes = {
  children: PropTypes.string.isRequired,
};

export default ActionButton;
